<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <v-icon icon="swipe_right" :title="t('component.iconManual.title')" />
</template>

<style scoped lang="scss"></style>
